import React, { useEffect, useState } from 'react';
import { config } from '../../../../../config';
import axiosApi from '../../../../../core/interceptor/interceptor';
import { Link, withRouter, useHistory, useLocation } from 'react-router-dom';
import back from '../../../../../assets/arrow-back.svg';
import { messages } from '../../../../../messages';
import './EventHeadline.css';
import TextEditor from '../../../../../Util/TextEditor/TextEditor';

function EventHeadLine() {
  const location = useLocation();
  
  const [formData, setFormData] = useState({
    headline: '',
    text_content: '',
  })
  const history = useHistory();
  const [errors, setErrors] = useState({ name: '', body: '', status: '' });
  const [formSubmitted, setFormSubmitted] = useState(false);

  const getHeadline = () => {
    axiosApi.get(`${config.apiUrl}/web-content/headline`)
      .then((res) => {
        setFormData((prev) => ({
          ...prev,
          headline: res?.data?.data?.headline,
          text_content: res?.data?.data?.text_content
        }));
      })
  }

  const getInclusionHeadline = () => {
    axiosApi.get(`${config.apiUrl}/web-content/inclusion-headline`)
      .then((res) => {
        setFormData((prev) => ({
          ...prev,
          headline: res?.data?.data?.headline,
          text_content: res?.data?.data?.text_content
        }));
      })
  }

  const handleFormChange = (e) => {
    // e.preventDefault();
    if (e && e.target && e.target.name === 'headline') {
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        text_content: e
      }))
    }
    
  }

  function handleValidation() {
    let errArray = {};
    let formIsValid = true;
    if (!formData.headline?.trim()) {
      formIsValid = false;
      errArray['headline'] = messages && messages.emptyTemplateName;
    }
    if (!formData.text_content?.trim()) {
      formIsValid = false;
      errArray['body'] = messages && messages.emptyTemplateBody;
    }
    setErrors(errArray);
    return formIsValid;
  }

  const handleSubmit = () => {
    let endPoint = '';
    if (location.pathname.includes('/event-headline')) {
      endPoint = 'headline';
    } else if (location.pathname.includes('/event-inclusion')) {
      endPoint = 'inclusion-headline';
    }
    setFormSubmitted(true);
    if (handleValidation()) {
      axiosApi.put(`${config.apiUrl}/web-content/${endPoint}`, formData)
        .then((res) => {
          if (res) {
            history.push(`/admin/events/website-content`);
          }
        })
    }
  }

  useEffect(() => {
    if (location.pathname.includes('/event-headline')) {
      getHeadline();
    } else if (location.pathname.includes('/event-inclusion')) {
      getInclusionHeadline();
    }
    // eslint-disable-next-line
  }, [])

  return (
    <>
      <div className='content-wrapper add-template-wrapper'>
        <div className="header">
          <Link to={{
            pathname: '/admin/events/website-content'
          }}>
            <button className='btn back-btn'><img src={back} alt='' />Back to Website Content</button>
          </Link>
          <div class="header-blk">
            <h2>{'Edit Event Headline'}</h2>
            <p>Set Event headline here.</p>
          </div>
        </div>
        <div className="inner-wrapper">
          <div className="flex-blk template-name-field">
            <label>Headline</label><br />
            <input type="text" name="headline" value={formData?.headline} onChange={(e) => handleFormChange(e)} id="search_bar" />
            <span className="error">{formSubmitted && errors['headline']}</span>
          </div>
          <div className="flex-blk message-field">
            <label>Text Content</label>
            <TextEditor name='text_content' edit={true} value={formData?.text_content} type='events' onChange={(e) => handleFormChange(e)} />
            <span className="error">{formSubmitted && errors['text_content']}</span>
          </div>
          <div className="flex-blk">
            <button type='button' onClick={() => handleSubmit()} className="btn">Save</button>
          </div>
        </div>
      </div>
    </>
  )
}
export default withRouter(EventHeadLine);